<template>
    <custom-search
        :label="label"
        :display-value="displayName"
        :disabled="!enabled"
        placeholder="Correo o nombre del usuario"
        :fetch-items="searchUsersByKeyword"
        @select="onSelect"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
    >
        <template #item="{ item }">
            <span class="flex items-center justify-between gap-2">
                <span>{{ item.email | cut(40) }}</span>
                <span
                    v-if="item.tenant"
                    class="text-xs text-theme-muted truncate"
                >
                    {{ item.tenant.name | cut(30) }}
                </span>
            </span>
        </template>
    </custom-search>
</template>

<script>
import { mapActions } from "vuex";

import CustomSearch from "@/components/utils/CustomSearch.vue";

// Busca usuarios en todos los tenants (GET /bo/users/search con `keyword`)
// para llegar al tenant de un usuario: cada usuario pertenece a un solo
// tenant, así que el usuario elegido trae su `tenantId`.
export default {
    name: "TenantUserSearch",
    components: {
        CustomSearch
    },
    model: {
        prop: "itemCurrent",
        event: "input"
    },
    props: {
        itemCurrent: {
            default: () => ({ id: "", email: "", tenantId: "" }),
            type: Object,
            required: false
        },
        label: {
            default: () => "",
            type: String,
            required: false
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["blur", "focus", "input"],
    computed: {
        displayName() {
            return this.itemCurrent.email || "";
        }
    },
    methods: {
        ...mapActions("users", ["searchUsers"]),
        searchUsersByKeyword(keyword) {
            return this.searchUsers({ keyword });
        },
        onSelect(item) {
            this.$emit("input", item);
        }
    }
};
</script>
